(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7c47"];
parcelRequire.register("lWF6y", function(module, exports) {
const $ff9ee64815ea81b9$var$eventsWFilterSections = document.querySelectorAll(".s-events-w-filter");
$ff9ee64815ea81b9$var$eventsWFilterSections.forEach((section)=>{
    const responseSettings = {
        method: "POST"
    };
    const filter = section.querySelector(".i-filter");
    const events = section.querySelector(".g-events");
    if (!filter || !events) return;
    filter.addEventListener("filter", async ()=>{
        events.classList.add("--loading");
        const response = await fetch("/events/filter", responseSettings);
        if (!response.ok) {
            events.classList.remove("--loading");
            return;
        }
    });
});

});

})();
//# sourceMappingURL=events-w-filter-section.c25b6872.js.map
